import React, { useState, useEffect, useRef } from "react"
import MetaTags from 'react-meta-tags';
import Select from "react-select"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  InputGroup,
  Input,
  Label,
  Spinner,
  Row,
  Button,
  Badge
} from "reactstrap"

import { useReactToPrint } from "react-to-print";
import { getSalesEntryList } from "helpers/backend_helper"
import * as moment from "moment"
import classnames from "classnames"
import { Link , useHistory} from "react-router-dom"
import { useSelector, useDispatch } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { setTimeCounter } from "store/products/actions"
import Breadcrumbs from "../../components/Common/Breadcrumb"

import Loader from "components/Common/Loader"
import { getAllCustomers as onGetAllCustomers } from "store/products/actions"
import { getStoreSettings as onGetStoreSettings } from "store/products/actions"
import COADropDown from "../../components/Product/COADropDown"

import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import { getStoreDetailsFromCache } from "helpers/cache_helper"

import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";

const PaymentEntry = (props) => {

  const history = useHistory()
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  });

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(onGetAllCustomers(true))
    dispatch(onGetStoreSettings(true))
    fetchStoreDetails()
  }, [dispatch]);

  const [searchInProgress, setSearchInProgress] = useState(false)
  const [noPendingRecords, setNoPendingRecords] = useState(false)
  const [storeDetails, setStoreDetails] = useState({})
  const [savedSuccessFully, setSavedSuccessFully] = useState(false)
  const [showErrorPopUp, setShowErrorPopUp] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [isEdit, setIsEdit] = useState(false)
  const [dataFetched, setDataFetched] = useState(false)

  const [showLoading, setShowLoading] = useState(false)
  const [selectedCustomer, setSelectedCustomer] = useState(null)
  const [paymentEntry, setPaymentEntry] = useState(initialisePaymentEntry())
  const [salesRows, setSalesRows] = useState([])
  

  const [validation, setValidation] = useState({
    receiptdate: null,
    suppinvoiceno: null,
  })

  function createNewPayment(){
    setSavedSuccessFully(false)
    setSelectedCustomer(null)
    setPaymentEntry(initialisePaymentEntry())
    setSalesRows([])
    setValidation({
      receiptdate: null,
      suppinvoiceno: null,
    })
  }

  const onBackToPaymentEntries = () => {
    history.push('/view-sales-receipts')
  }

  const { customerList, settings} = useSelector(state => ({
    customerList: state.Products.customers,
    settings: state.Products.settings,
  }))

  function initialisePaymentEntry(){
    return {
      receiptdate: moment(new Date()).format("yyyy-MM-DD HH:mm"),
      cashreceived: '0',
      paymentaccountid: '',
      reference: '',
      totalcurrentbalance: 0,
      totalamoutallocated: 0,
      totalwriteoff: 0,
      totalfinalbalance: 0
    }
  }
  function fetchStoreDetails(){
    getStoreDetailsFromCache(true).then(resp =>{
      setStoreDetails(resp)
    })
  }
  const {
    match: { params },
  } = props

  useEffect(() => {
    if (params && params.id) {
      getSalesDetails(params.id)

      setPaymentEntry({
        ...paymentEntry,
        customerid : params.id
      })
      const selectedCust = customerList.filter(each => each.value == params.id)
      setSelectedCustomer(selectedCust)

    } 
  }, [])

  function allocateEnteredCash(cashRecieved){
    recalculateEachRow(salesRows,cashRecieved)
    validateTotal()
  }

  function recalculateEachRow(salesRowsInp, cashRecievedInp){
    if(!cashRecievedInp || cashRecievedInp == ''){
      cashRecievedInp = 0
    }
    let balanceAfterAllocation = cashRecievedInp
    var updatedRows = []
    salesRowsInp.forEach(each => {
      if(Number(balanceAfterAllocation) + Number(each.writeoff) <= Number(each.currentbalance)){
          each["amountallocated"] = Number(balanceAfterAllocation)
          each["finalbalance"] = Number(each.currentbalance) - (Number(balanceAfterAllocation)+Number(each.writeoff))
          balanceAfterAllocation = 0
          updatedRows.push(each)
      }
      else{
        each["amountallocated"] = Number(each.currentbalance) - Number(each.writeoff)
        each["finalbalance"] = 0
        balanceAfterAllocation = (Number(balanceAfterAllocation) + Number(each.writeoff)) -  Number(each.currentbalance)
        updatedRows.push(each)
      }
    })
    if(updatedRows.length == 0){
      setNoPendingRecords(true)
    }
    else{
      setNoPendingRecords(false)
    }
    setSalesRows(updatedRows)
  }

  function handleAmountChange(id, value) {
    var modifiedRows = [...salesRows]
    modifiedRows = modifiedRows.map(eachRow => {
      if(eachRow["id"] == id && (Number(eachRow.currentbalance) >= Number(value))){
        let writeOff = eachRow.writeoff
        if(Number(value)+Number(eachRow.writeoff) > Number(eachRow.currentbalance)){
          writeOff = Number(eachRow.currentbalance) - Number(value)
        }
        return {
          ...eachRow,
          amountallocated: value,
          writeoff: writeOff,
          finalbalance: Number(eachRow.currentbalance) - (Number(writeOff) + Number(value))
        }
      }
      else {
        return eachRow
      }
    })
    setSalesRows(modifiedRows)
  }

  function handleWriteOffChange(id, value) {
    var modifiedRows = [...salesRows]
    modifiedRows = modifiedRows.map(eachRow => {
      let balance = Number(eachRow.currentbalance) - (Number(eachRow.amountallocated)+ Number(value))
      if(eachRow["id"] == id && balance >= 0){
        eachRow["writeoff"] = value
        eachRow["finalbalance"] = Number(eachRow.currentbalance) - (Number(eachRow.amountallocated) + Number(value))
        return {
          ...eachRow,
          writeoff: value,
          finalbalance: Number(eachRow.currentbalance) - (Number(eachRow.amountallocated) + Number(value))
        }
      }
      else {
        return eachRow
      }
    })
    setSalesRows(modifiedRows)
  }

  useEffect(() => {
    let totalCurrentBalance = 0
    let totalAmoutAllocated = 0
    let totalWriteOff = 0
    let totalFinalBalance = 0
    salesRows.forEach(each =>{
      totalCurrentBalance = Number(totalCurrentBalance) + Number(each.currentbalance)
      totalAmoutAllocated = Number(totalAmoutAllocated) + Number(each.amountallocated)
      totalWriteOff = Number(totalWriteOff) + Number(each.writeoff)
      totalFinalBalance = Number(totalFinalBalance) + Number(each.finalbalance)
    })

    setPaymentEntry({
      ...paymentEntry,
      totalcurrentbalance : totalCurrentBalance,
      totalamoutallocated: totalAmoutAllocated,
      totalwriteoff: totalWriteOff,
      totalfinalbalance: totalFinalBalance
    })
  }, [salesRows]);

  async function getPaymentEntryDetails(pdtid){
    const response = await getPaymentEntryForEditDirect(pdtid)
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.id){
      setPaymentEntryForEdit((response))
    }
    setShowLoading(false)
  }

  function getSalesDetails(custname){
    let searchCriteria = {
      customerid: custname,
      status : 'DUE,OVERDUE,OPEN',
    }
    setSearchInProgress(true)
    setDataFetched(true)
    getSalesEntryList(searchCriteria).then(result => {
      if(result && result.length > 0){
        result = result.map(each => {
          return {
            ...each,
            currentbalance: Number(each.grandtotal) - (Number(each.cashreceived) + Number(each.currentwriteoff)),
            amountallocated : 0,
            writeoff : 0,
            finalbalance : Number(each.grandtotal) - (Number(each.cashreceived) + Number(each.currentwriteoff)),
          }
        })
        result = result.reverse()
      }
      recalculateEachRow(result,paymentEntry.cashreceived)
      
      //setSalesRows(result)
      setSearchInProgress(false)
    })
  }

  const mandatoryFields = ['receiptdate','customerid']

  const onChangeValidation = (fieldName, value) => {
    if(mandatoryFields.includes(fieldName)){
      const modifiedV = { ...validation }
      if (value !== "") {
        modifiedV[fieldName] = true
      } else {
        modifiedV[fieldName] = false
      }
      setValidation(modifiedV)
    }
  }


  function isNumber(num){
    if(Number(num) || num == 0){
      return true;
    }
    else{
      return false;
    }
  }

  function validateTotal(){
    let formValid = true;
    const modifiedV = { ...validation }

    if(paymentEntry.cashreceived != "" && Number(paymentEntry.cashreceived) > 0){
      if(Number(paymentEntry.cashreceived) != Number(paymentEntry.totalamoutallocated)){
        modifiedV["invalidsum"] = false
        formValid = false
      }
      else{
        modifiedV["invalidsum"] = true
      }
    }
    else{
      modifiedV["invalidsum"] = true
    }

    setValidation(modifiedV)
    return formValid
  }

  function validateFormSubmit(){
    let formValid = true;
    const modifiedV = { ...validation }
    mandatoryFields.forEach(eachItem =>{
      if(paymentEntry[eachItem] && paymentEntry[eachItem].trim() != ""){
        modifiedV[eachItem] = true
      }
      else{
        modifiedV[eachItem] = false
        formValid = false
      }
    })

    if(paymentEntry.cashreceived != "" && Number(paymentEntry.cashreceived) > 0){
      if(Number(paymentEntry.cashreceived) != Number(paymentEntry.totalamoutallocated)){
        modifiedV["invalidsum"] = false
        formValid = false
      }
      else{
        modifiedV["invalidsum"] = true
      }
    }
    else{
      modifiedV["invalidsum"] = true
    }

    if(Number(paymentEntry.totalamoutallocated) == 0){
      modifiedV["noamount"] = false
      formValid = false
    }
    else{
      modifiedV["noamount"] = true
    }

    setValidation(modifiedV)

    return formValid
  }

  function savePaymentEntry(){
    let isFormValid = validateFormSubmit()
    if(isFormValid){
      isFormValid = validateTotal()
    }
    
    console.log('isFormValid?:'+isFormValid)
    if(isFormValid){
      const paymentEntryTemp = { ...paymentEntry }
      paymentEntryTemp["salesitems"] = salesRows
      submitCreateNewPaymentEntry(paymentEntryTemp)
    }
  }

  async function submitCreateNewPaymentEntry(paymentEntryDetails) {
    setShowLoading(true)
    const response = await onAddItemDirect(paymentEntryDetails, 'PaymentEntry')
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.status === 'success'){

      setSuccessMessage('Payment Entry added successfully.')
      setSavedSuccessFully(true)
      setShowSuccessPopUp(true)
      
    }
    dispatch(setTimeCounter(1500000))
    setShowLoading(false)
  }

  const formatDate = date => {
    return moment(new Date(date)).format("DD MMM Y")
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Payment Entry | Flamingo</title>
        </MetaTags>
        <Loader showLoader={showLoading} />
        <Container fluid>
          {isEdit ? 
          <Breadcrumbs title="Sales" breadcrumbItem="Edit Sales Payment Entry" /> 
          :
          <Breadcrumbs title="Sales" breadcrumbItem="Sales Payment Entry" />
          }
          <Row>
            <Col lg="12">
              <Card style={{minHeight:"550px"}}>
                <CardBody>
                  <Form>
                    <Row>
                      <Col lg="12">
                        <Row>
                          <Col lg="2">
                            <FormGroup className="mb-4">
                              <Label>Receipt Date</Label>
                              <InputGroup>
                                <Flatpickr
                                  id="receiptdate"
                                  className="form-control d-block"
                                  placeholder="dd MM yyyy H:i"
                                  value={paymentEntry.receiptdate}
                                  options={{
                                    enableTime: true,
                                    altInput: true,
                                    altFormat: "j M Y, H:i",
                                    dateFormat: "Y-m-d H:i",
                                  }}
                                  onChange={date => {
                                    const date1 = moment(new Date(date)).format("yyyy-MM-DD HH:mm ")
                                    setPaymentEntry({
                                      ...paymentEntry,
                                      receiptdate : date1
                                    })
                                    onChangeValidation("receiptdate", date1)
                                  }}
                                />
                                {(validation["receiptdate"] === false) &&
                                  <div className="custom-error">
                                    Please select the Receipt Date
                                  </div>
                                }
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col lg="4">
                            <FormGroup className="mb-4">
                              <Label>Select Customer</Label>
                                <Select
                                  onChange={(e) => {
                                    setPaymentEntry({
                                      ...paymentEntry,
                                      customerid : e.value
                                    })
                                    setSelectedCustomer(e)
                                    getSalesDetails(e.value)
                                    onChangeValidation("customerid", e.value)
                                  }}
                                  value={selectedCustomer}
                                  options={customerList}
                                  classNamePrefix="select2-selection"
                                  isLoading={false}
                                  id="productcustomer"
                                />
                                {(validation["customerid"] === false) &&
                                  <div className="custom-error">
                                    Please select the Customer
                                  </div>
                                }
                            </FormGroup>
                          </Col>
                          {isEdit && <Col className="ms-3" lg="2">
                            <FormGroup className="mb-4">
                              <Label>Receipt No.
                              <Badge className={paymentEntry.status== "ACTIVE"? "ms-2 font-size-12 bg-success badge-success":"ms-2 font-size-12 bg-warning badge-warning"}>
                                {paymentEntry.status}
                              </Badge>
                              </Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  disabled
                                  value={paymentEntry.invoiceno || ''}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          }
                        </Row>
                        <Row>
                          <Col lg="2">
                            <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                              <Label>
                                Deposit Account
                              </Label>
                              <COADropDown 
                                id={paymentEntry.paymentaccountid || ''}
                                groupCode="CH,BA"
                                accountType="CASH"
                                selectOnChange={e =>{
                                  setPaymentEntry({
                                    ...paymentEntry,
                                    paymentaccountid : e.value,
                                  })
                                }}
                                >
                              </COADropDown>
                            </div>
                          </Col>
                          <Col lg="2">
                            <FormGroup className="mb-3">
                              <Label>Amount Received</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="cashreceived"
                                  maxLength="10"
                                  value={paymentEntry.cashreceived.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                                  onChange={e => {
                                    if(isNumber(e.target.value) || (e.target.value== '')){
                                      let enteredVal = e.target.value
                                      if(e.target.value== ''){
                                        enteredVal = 0;
                                      }
                                      setPaymentEntry({
                                        ...paymentEntry,
                                        cashreceived : e.target.value,
                                        //balanceamount: (Number(salesEntry.grandtotal) - Number(e.target.value)).toFixed(2)
                                      })
                                      allocateEnteredCash(enteredVal)
                                    }
                                  }}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col lg="2">
                            <FormGroup className="mb-3">
                              <Label>Reference</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="reference"
                                  maxLength="30"
                                  value={paymentEntry.reference}
                                  onChange={e => {
                                    setPaymentEntry({
                                      ...paymentEntry,
                                      reference : e.target.value,
                                    })
                                  }}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>

                        </Row>
                      </Col>
                    </Row>

                    {dataFetched && <div className="inner-repeater mb-3 mt-3">
                    {searchInProgress ? 
                    <Row className="text-center">
                      <Col>
                        <Spinner style={{ width: '3.2rem', height: '3.2rem' }} className="ms-3" color="primary" /> 
                      </Col>
                    </Row>
                    :
                      <div className="table-responsive">
                        <table style={{ width: "100%" }} className="0">
                          <tbody>
                            <tr className="custom-table-sales-header">
                              <td>
                                <Row className="no-gutters">
                                  <Col lg="6" xs="6">
                                    <Row className="no-gutters text-center">
                                      <Col className="custom-table-header-cell" xs="3">Date</Col>
                                      <Col className="custom-table-header-cell" xs="6">Description</Col>
                                      <Col className="custom-table-header-cell" xs="3">Total Amount</Col>
                                    </Row>
                                  </Col>
                                  <Col lg="6" xs="6">
                                    <Row className="no-gutters text-center">
                                      <Col className="custom-table-header-cell" xs="3">Current Balance</Col>
                                      <Col className="custom-table-header-cell" xs="3">Amount Allocated</Col>
                                      <Col className="custom-table-header-cell" xs="3">Write-Off</Col>
                                      <Col className="custom-table-header-cell" xs="3">Final Balance</Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                          
                            {(salesRows || []).map((formRow, key) => (
                              <tr key={key}>
                                <td>
                                  <Row className="no-gutters">
                                    <Col lg="6" xs="6">
                                      <Row className="no-gutters">
                                        <Col xs="3">
                                          <Input
                                            type="text"
                                            className=" text-center"
                                            disabled
                                            value={formatDate(formRow.invoicedate) || ''}
                                          />
                                        </Col>
                                        <Col xs="6">
                                          <Input
                                            type="text"
                                            className=""
                                            disabled
                                            value={formRow.invoiceno || ''}
                                          />
                                        </Col>
                                        <Col xs="3">
                                          <Input
                                            type="text"
                                            className=" text-center"
                                            disabled
                                            value={(Number(formRow.grandtotal).toLocaleString('en-IN',{minimumFractionDigits: 2}) || '')}
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col lg="6" xs="6">
                                      <Row className="no-gutters">
                                        <Col xs="3">
                                          <Input
                                            type="text"
                                            className=" text-center"
                                            disabled
                                            value={(Number(formRow.currentbalance).toLocaleString('en-IN',{minimumFractionDigits: 2}) || '')}
                                          />
                                        </Col>
                                        <Col xs="3">
                                          <Input
                                            type="text"
                                            className=" text-center"
                                            value={(salesRows.filter(x => x["id"]==formRow.id)[0].amountallocated)}
                                            onChange={e => {
                                              if(isNumber(e.target.value)){
                                                //handleAllocateAmountChange(formRow.id, e.target.value)
                                                handleAmountChange(formRow.id, e.target.value)
                                              }
                                            }}
                                          />
                                        </Col>
                                        <Col xs="3">
                                          <Input
                                            type="text"
                                            className=" text-center"
                                            value={(salesRows.filter(x => x["id"]==formRow.id)[0].writeoff)}
                                            onChange={e => {
                                              if(isNumber(e.target.value)){
                                                handleWriteOffChange(formRow.id, e.target.value)
                                              }
                                            }}
                                          />
                                        </Col>
                                        <Col xs="3">
                                          <Input
                                            type="text"
                                            className=" text-center"
                                            disabled
                                            value={Number(formRow.finalbalance).toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                                          />
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                </td>
                              </tr>
                            ))}

                            { !noPendingRecords ?
                              
                            <tr className="custom-table-footer">
                              <td>
                                <Row className="no-gutters">
                                  <Col lg="6" xs="6">
                                    <Row className="no-gutters text-center">
                                      <Col className="" xs="3"></Col>
                                      <Col className="" xs="6"></Col>
                                      <Col className="pt-2 fw-medium display-10" xs="3">Total</Col>
                                    </Row>
                                  </Col>
                                  <Col lg="6" xs="6">
                                    <Row className="no-gutters text-center">
                                      <Col className="" xs="3">
                                        <Input
                                          type="text"
                                          disabled
                                          className="nopadd text-center form-control fw-medium"
                                          value={paymentEntry.totalcurrentbalance.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                                        />
                                      </Col>
                                      <Col className="" xs="3">
                                        <Input
                                          type="text"
                                          disabled
                                          className="nopadd text-center form-control fw-medium"
                                          value={paymentEntry.totalamoutallocated.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                                        />
                                      </Col>
                                      <Col className="" xs="3">
                                        <Input
                                          type="text"
                                          disabled
                                          className="nopadd text-center form-control fw-medium"
                                          value={paymentEntry.totalwriteoff.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                                        />
                                      </Col>
                                      <Col className="" xs="3">
                                        <Input
                                          type="text"
                                          disabled
                                          className="nopadd text-center form-control fw-medium"
                                          value={paymentEntry.totalfinalbalance.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                            :
                            <tr className="custom-table-footer text-center text-success">
                              <td className="py-3 font-size-15">
                                No payment pending sales.
                              </td>
                            </tr>}
                          </tbody>
                        </table>
                      </div>}
                    </div>}

                    {(validation["invalidsum"] === false) &&
                      <div className="text-center clearfix custom-error mb-0 font-size-12">
                        Amount Received & Collected doesnt match. Please check.
                      </div>
                    }
                    {(validation["noamount"] === false) &&
                      <div className="text-center clearfix custom-error mb-0 font-size-12">
                        Please enter the amount.
                      </div>
                    }

                    {dataFetched && !searchInProgress && !noPendingRecords && <div className="text-center clearfix">
                      <Button
                        color="secondary"
                        disabled={savedSuccessFully}
                        className="btn w-lg btn-info mt-3 me-2"
                        onClick={() => {
                          savePaymentEntry()
                        }}
                        >
                          SAVE
                      </Button>

                      {savedSuccessFully && <Button
                        color="primary"
                        className="btn w-lg btn-primary mt-3 me-2"
                        onClick={() => {
                          createNewPayment()
                        }}
                        >
                          <i className="bx bx-plus me-1"></i>Add New Payment
                      </Button>}
                    </div>}

                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {showErrorPopUp ? (
        <SweetAlert
          error
          title="Failed"
          onConfirm={() => {
            setShowErrorPopUp(false)
          }}
        >
          {errorMessage}
        </SweetAlert>
      ) : null}
      {showSuccessPopUp ? (
        <SweetAlert
          title="Success!"
          success
          customButtons={
            <>
            <Button
              color="info"
              className="btn btn-info me-2"
              onClick={() => {
                setShowSuccessPopUp(false)
                onBackToPaymentEntries()
              }}
              >
                <i className="bx bx-printer me-1"></i>All Receipts
            </Button>

            <Button
              color="primary"
              className="btn btn-primary me-2"
              onClick={() => {
                setShowSuccessPopUp(false)
                createNewPayment()
              }}
              >
                <i className="bx bx-plus me-1"></i>New Payment
            </Button>
            
            <Button
              color="warning"
              className="btn btn-warning me-2"
              onClick={() => {
                setShowSuccessPopUp(false)
              }}
              >
                <i className="bx bx-window-close me-1"></i>Close
            </Button>
            </>
          }
          
        >
          {successMessage}
        </SweetAlert>
      ) : null}

    </React.Fragment>
  )
}

export default PaymentEntry
